import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import ReleasesStore from "./ReleasesStore";

const releasesRoute: RouteType[] = [
  {
    name: "Releases",
    path: "/devops/releases",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Releases",
        enableRefreshButton: true,
        component: () => import("./Releases.Header"),
      },
      body: {
        component: () => import("./Releases.Body"),
        grayBackground: true,
      },
    },
    group: "DevOps",
    // The words a user who cannot remember "Releases" types into the omnibar.
    searchAliases: ["deploy", "deployment", "release pipeline"],
    // Read-only status board. Reads require authentication only (viewer+); the
    // API enforces the read gate. Starting a release is operator/admin — gated
    // in the store (`canManage`) and enforced by the API RBAC seam.
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.releasesStore as ReleasesStore;
      store?.initialize();
    },
    // Mirrors Pipelines: the store's teardown seam on leave (today it discards
    // an unsaved Create Release form; a live feed lands here when it exists).
    onExit: ({ rootStore }) => {
      const store = rootStore.releasesStore as ReleasesStore;
      store?.dispose();
    },
    dialogs: [
      {
        name: "DevOpsReleaseFormDialog",
        title: "Create Release",
        submitButtonText: "Create release",
        component: () => import("./dialogs/ReleaseForm.Body"),
        cancelButton: true,
        height: 480,
        onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.releasesStore as ReleasesStore;
          const ok = await store.createRelease();
          // Throwing keeps the dialog open so the API error stays visible in
          // the form's alert.
          if (!ok) {
            throw new Error(store.formError || "Failed to create release");
          }
        },
        onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.releasesStore as ReleasesStore;
          return store.isFormValid;
        },
      },
    ],
  },
];

export default releasesRoute;
